import script from "./LeaderProjectFormStep5.vue?vue&type=script&setup=true&lang=js"
export * from "./LeaderProjectFormStep5.vue?vue&type=script&setup=true&lang=js"

import "./LeaderProjectFormStep5.vue?vue&type=style&index=0&id=0a9a150f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a9a150f"]])

export default __exports__